import { render, staticRenderFns } from "./ServicosDoPlano.vue?vue&type=template&id=2d442408"
import script from "./ServicosDoPlano.vue?vue&type=script&lang=js"
export * from "./ServicosDoPlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports